import { ActionIcon, Tooltip, type MantineStyleProp, Menu, useMantineTheme } from '@mantine/core';

import { useState } from 'react';

import { IconDots } from '@tabler/icons-react';

interface ThreeDotProps {
  menuItems: Array<{
    icon?: React.ReactNode
    label: string | React.ReactNode
    onClick: () => void
    shouldRender: boolean
    color?: string
    disabled?: boolean
    disabledHelpText?: string
  }>
  dropDownMenuStyle?: MantineStyleProp
  iconColor?: 'primary' | 'secondary'
}

const ThreeDotsMenu: React.FC<ThreeDotProps> = (props: ThreeDotProps) => {
  const {
    menuItems,
    dropDownMenuStyle
  } = props;
  const [opened, setOpened] = useState(false);
  const { other: colorVars } = useMantineTheme();
  const iconColor = props.iconColor === 'primary' ? colorVars.primaryIconColor : colorVars.secondaryIconColor;
  return (
    <Menu
      position='bottom-end'
      opened={opened}
      onChange={setOpened}
    >
      <Menu.Target>
        <ActionIcon
          size='lg'
          variant='subtle'
          onClick={(event: React.MouseEvent<HTMLElement>) => {
            event.stopPropagation();
            setOpened((o) => !o);
          }}
        >
          <IconDots color={iconColor} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown style={dropDownMenuStyle ?? {}}>
        {
          menuItems.map((item, index) =>
            item.shouldRender &&
            <Tooltip
              key={+index}
              onClick={(e) => { e.stopPropagation(); }}
              events={{
                hover: item.disabled === true && item.disabledHelpText !== undefined,
                focus: false,
                touch: false
              }}
              label={item.disabledHelpText}
              position='left'
            >
              <Menu.Item
                disabled={item.disabled}
                c={item.color}
                leftSection={item.icon}
                onClick={(event) => {
                  event.stopPropagation();
                  item.onClick();
                }}
              >
                {item.label}
              </Menu.Item>
            </Tooltip>)
        }
      </Menu.Dropdown>
    </Menu >
  );
};

export default ThreeDotsMenu;
